module.exports = __webpack_public_path__ + "static/img/tit1.abab60d3.png";